<template>
    <div class="matches">
        <div class="title-wrapper">
            <span class="bracket-wrapper">
                <img class="bracket" src="~@/assets/celtic_bracket.png" />
            </span>
            <h1 class="title">
                Recent Matches
            </h1>
            <span class="bracket-wrapper left">
                <img class="bracket flipped" src="~@/assets/celtic_bracket.png" />
            </span>
        </div>
        <div class="filters-wrapper" v-if="loaded">
            <div class="expansion-icons" v-if="isMobile">
                <span
                    class="expansion-filter-icon text-label"
                    :class="{ enabled: filters.base }"
                    @click="toggleExpansionIcon('base')"
                    title="Base"
                >
                    Base
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.nobility }"
                    @click="toggleExpansionIcon('nobility')"
                    title="Nobility"
                >
                    <fa-icon icon="crown" class="expansion-icon nobility" />
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.siege }"
                    @click="toggleExpansionIcon('siege')"
                    title="Siege"
                >
                    <icon icon="fort" class="expansion-icon siege" />
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.nightfall }"
                    @click="toggleExpansionIcon('nightfall')"
                    title="Nightfall"
                >
                    <icon icon="poison" class="expansion-icon nightfall" />
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.shockTactics }"
                    @click="toggleExpansionIcon('shockTactics')"
                    title="Shock Tactics"
                >
                    <ShockIcon class="expansion-icon shock-tactics" />
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.champions }"
                    @click="toggleExpansionIcon('champions')"
                    title="Champions"
                >
                    <WingedHelmetIcon class="expansion-icon champions" />
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.mastery }"
                    @click="toggleExpansionIcon('mastery')"
                    title="Mastery"
                >
                    <fa-icon icon="feather" class="expansion-icon mastery" />
                </span>
                <span
                    class="expansion-filter-icon"
                    :class="{ enabled: filters.highSeas }"
                    @click="toggleExpansionIcon('highSeas')"
                    title="High Seas"
                >
                    <icon icon="ship" class="expansion-icon high-seas" />
                </span>
            </div>
            <div class="expansion-filters" v-else>
                <label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        Base Game
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="base"
                        v-model="filters.base"
                        type="checkbox"
                        @input="onToggleBaseGameFilter(!filters.base)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
                <label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        Nobility
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="nobility"
                        v-model="filters.nobility"
                        type="checkbox"
                        @input="onToggleExpansionFilter('nobility', !filters.nobility)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
                <label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        Siege
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="siege"
                        v-model="filters.siege"
                        type="checkbox"
                        @input="onToggleExpansionFilter('siege', !filters.siege)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
                <label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        Nightfall
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="nightfall"
                        v-model="filters.nightfall"
                        type="checkbox"
                        @input="onToggleExpansionFilter('nightfall', !filters.nightfall)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
                <label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        Shock Tactics
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="shockTactics"
                        v-model="filters.shockTactics"
                        type="checkbox"
                        @input="onToggleExpansionFilter('shockTactics', !filters.shockTactics)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
				<label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
						Champions
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="champions"
                        v-model="filters.champions"
                        type="checkbox"
                        @input="onToggleExpansionFilter('champions', !filters.champions)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
                <label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        Mastery
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="mastery"
                        v-model="filters.mastery"
                        type="checkbox"
                        @input="onToggleExpansionFilter('mastery', !filters.mastery)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
				<label class="pseudo-checkbox-wrapper">
                    <span class="filter-label">
                        High Seas
                    </span>
                    <input
                        class="pseudo-checkbox-input"
                        name="highSeas"
                        v-model="filters.highSeas"
                        type="checkbox"
                        @input="onToggleExpansionFilter('highSeas', !filters.highSeas)"
                    />
                    <span class="psuedo-checkbox green">
                        <fa-icon icon="check" class="checkmark" />
                    </span>
                </label>
            </div>
            <button class="btn btn-primary btn-3d" @click="getGames(1)">
                Filter
            </button>
            <button class="btn btn-muted btn-3d" @click="onClearFilters">
                Clear
            </button>
        </div>
        <div class="loading-matches" v-if="!loaded">
            Loading matches<span class="ellipsis animated-ellipsis"></span>
        </div>
        <table class="matches-table" v-if="loaded && games.length">
            <thead>
                <tr class="table-header">
                    <th class="hide-on-mobile">
                        Date
                    </th>
                    <th class="hide-on-mobile hide-on-medium" colspan="2">
                        Room Name
                    </th>
                    <th>
                        Players
                    </th>
                    <th class="text-center hide-on-mobile">
                        Score
                    </th>
                    <th class="text-center">
                        Winner
                    </th>
                    <th class="hide-on-mobile"></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="game in games" :key="`game-${game.id}`">
                    <td class="match-date hide-on-mobile" >
                        {{formatDate(game.createdAt)}}
                    </td>
                    <td class="ranked-cell hide-on-mobile hide-on-medium">
                        <span class="ranked-icon-wrapper">
                            <fa-icon :icon="game.ranked ? 'trophy' : 'smile'"
                                class="ranked-icon"
                                :class="{
                                    ranked: game.ranked,
                                    unranked: !game.ranked,
                                }"
                            />
                        </span>
                    </td>
                    <td class="room-name-cell hide-on-mobile hide-on-medium">
                        {{game.roomName}}
                    </td>
                    <td class="teams-wrapper">
                        <div class="teammates">
                            <div class="match-player" v-for="(player) in getPlayersInTeam(game, 'white')" :key="player.id">
                                <div class="username">
                                    <span class="team-color">
                                        <royal-coin class-name="royal-coin" color="white" />
                                    </span>
                                    <router-link
                                        :to="`/matches/${encodeLabel(player.user.username)}`"
                                        class="link"
                                        target="_blank"
                                    >
                                        {{formatUsername(player.user.username)}}
                                    </router-link>
                                </div>
                                <div class="player-units">
                                    <img
                                        class="unit-coin"
                                        :src="getAssetUrl(`@/assets/units/${unitType.imageName}`)"
                                        v-for="(unitType) in getUnitTypes(player.units)"
                                        :key="`unit-type-${game.id}-${unitType.id}`"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="teams-separator">
                            VS.
                        </div>
                        <div class="teammates">
                            <div class="match-player" v-for="(player) in getPlayersInTeam(game, 'black')" :key="player.id">
                                <div class="username">
                                    <span class="team-color">
                                        <royal-coin class-name="royal-coin" color="black" />
                                    </span>
                                    <router-link
                                        :to="`/matches/${encodeLabel(player.user.username)}`"
                                        class="link"
                                        target="_blank"
                                    >
                                        {{formatUsername(player.user.username)}}
                                    </router-link>
                                </div>
                                <div class="player-units">
                                    <img
                                        class="unit-coin"
                                        :src="getAssetUrl(`@/assets/units/${unitType.imageName}`)"
                                        v-for="(unitType) in getUnitTypes(player.units)"
                                        :key="`unit-type-${game.id}-${unitType.id}`"
                                    />
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="text-center team-score-td hide-on-mobile">
                        <span class="team-score-wrapper" v-for="(team, i) in getTeams(game)" :key="`team-${i}`">
                            <span class="team-color">
                                <royal-coin class-name="royal-coin" :color="team.color" />
                            </span>
                            <span class="team-score">{{team.controlledBases.length}}</span>
                        </span>
                    </td>
                    <td
                        class="match-result text-center"
                        :class="{[getWinningTeam(game).color]: true}"
                    >
                        <royal-coin class-name="royal-coin" :color="getWinningTeam(game).color" />
                    </td>
                    <td class="text-center hide-on-mobile">
                        <router-link
                            class="nav-link"
                            :to="{
                                name: 'game',
                                    params: {
                                    id: game.id,
                                    redirect: '/recent-matches'
                                }
                            }"
                        >
                            <button class="btn btn-muted btn-3d">
                                View
                            </button>
                        </router-link>
                    </td>
                    <td class="text-center">
                        <router-link
                            :to="{
                                name: 'replay',
                                params: {
                                    id: game.id,
                                    redirect: '/recent-matches'
                                }
                            }"
                            class="nav-link" v-if="gameHasSnapshots(game)"
                        >
                            <button class="btn btn-primary btn-3d replay-btn">
                                Replay
                            </button>
                            <fa-icon class="icon replay-icon" icon="play" />
                        </router-link>
                        <button class="btn btn-muted btn-3d replay-btn disabled" v-if="!gameHasSnapshots(game)">
                              Replay
                        </button>
                        <fa-icon class="icon replay-icon disabled" icon="play" v-if="!gameHasSnapshots(game)" />
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="matches-placeholder" v-if="loaded && !games.length">
            No matches available.
        </div>
        <paginator
            v-if="loaded && games.length"
            :onGoToPageCallback="goToPage"
            :pages="pages"
            :currentPage="page"
        />
    </div>
</template>

<script>
import { getAssetUrl } from '../../helpers/assets';
import moment from 'moment';

import {
    formatUsername,
    gameHasSnapshots,
    isMobileDevice,
} from '../../helpers/general';
import { MOBILE_MAX_WIDTH } from '../../App-types';
import WingedHelmetIcon from '../../assets/winged_helmet.svg';
import ShockIcon from '../../assets/shock_icon.svg';
import {
    UNIT_TYPE_ROYAL_COIN,
    UNIT_TYPE_DECOY_COIN,
} from '../Unit/Unit-types';
import api from '../../helpers/api';

export default {
    name: 'RecentMatches',
    components: {
        WingedHelmetIcon,
        ShockIcon,
    },
    async created() {
        this.windowWidth = window.innerWidth;
        window.addEventListener('resize', this.onWindowResize);
        await this.getGames(this.page);
    },
    unmounted() {
        window.removeEventListener('resize', this.onWindowResize);
    },
    data() {
        return {
            loaded: false,
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        isMobile() {
            return this.windowWidth <= MOBILE_MAX_WIDTH || isMobileDevice();
        },
        recentMatchesState() {
            return this.$store.state.recentMatchesState;
        },
        filters() {
            return this.recentMatchesState.filters;
        },
        games() {
            return this.recentMatchesState.games;
        },
        pages() {
            return this.recentMatchesState.pages;
        },
        page() {
            return this.recentMatchesState.page;
        },
    },
    methods: {
        onWindowResize() {
            this.windowWidth = window.innerWidth;
        },
        getAssetUrl,
        encodeLabel(label) {
            return encodeURIComponent(label);
        },
        formatDate(date) {
            return moment(date).local().format('YYYY/MM/DD H:mm');
        },
        formatUsername(username) {
            return formatUsername(username);
        },
        gameHasSnapshots(game) {
            return gameHasSnapshots(game);
        },
        getPlayersInTeam(game, color) {
            return game.players.filter(player => player.team.color === color);
        },
        async getGames(page) {
            const {
                base,
                nobility,
                siege,
                nightfall,
                mastery,
                shockTactics,
				highSeas,
				champions,
            } = this.filters;

            this.loaded = false;

            const url = `/game/all?page=${page}` +
                `&filters[base]=${base}` +
                `&filters[nobility]=${nobility}` +
                `&filters[siege]=${siege}` +
                `&filters[nightfall]=${nightfall}` +
                `&filters[shockTactics]=${shockTactics}` +
                `&filters[mastery]=${mastery}` +
                `&filters[highSeas]=${highSeas}` +
                `&filters[champions]=${champions}`;


            const response = await api.request(url, 'GET');

            if (response.ok) {
                const gamesResponse = await response.json();
                this.$store.dispatch('setRecentMatchesGames', gamesResponse.data);
                this.loaded = true;

                if (gamesResponse.pages !== this.pages) {
                    const pages = [];

                    for (let i = 0; i < gamesResponse.pages; i++) {
                        pages.push(i + 1);
                    }

                    this.$store.dispatch('setRecentMatchesPages', pages);
                }
            }

            if (page === 1 && this.page !== 1) {
                this.$store.dispatch('setRecentMatchesPage', 1);
            }

            this.loaded = true;
        },
        getPlayer(game, userId) {
            return game.players.filter(player => player.user.id === userId)[0];
        },
        getTeammate(game, userId) {
            const player = this.getPlayer(game, userId);
            return game.players.filter(gamePlayer =>
                gamePlayer.user.id !== userId &&
                gamePlayer.team.id === player.team.id,
            )[0];
        },
        getWinningTeam(game) {
            return game.teams
                .filter(team => team.id === game.winningTeamId)[0];
        },
        getOpponents(game, userId) {
            const currentPlayer = this.getPlayer(game, userId);
            return game.players.filter(player => player.team.id !== currentPlayer.team.id);
        },
        getResult(player, winningTeamId, game) {
            const teams = this.getTeams(game);
            const scores = teams.map(team => team.controlledBases.length);

            const forfeit = game.numOfPlayers === 2 ? !scores.includes(6) : !scores.includes(8);
            return (player.team.id === winningTeamId ? 'Win' : 'Loss') + (forfeit ? '<br/> (forfeit)' : '');
        },
        isWinner(player, winningTeamId) {
            return player.team.id === winningTeamId;
        },
        getSrChange(player) {
            return Math.abs(player.nextSkillRating - player.prevSkillRating);
        },
        getResultClass(player, winningTeamId, game) {
            return this.getResult(player, winningTeamId, game).split(/[^A-Za-z]/)[0].toLowerCase();
        },
        getTeams(game) {
            const teams = [];
            const teamIds = [];
            game.players.map((player) => {
                if (!teamIds.includes(player.team.id)) {
                    teamIds.push(player.team.id);
                    teams.push(player.team);
                }
            });
            return teams;
        },
        getUnitTypes(units) {
            const unitsByType = {};

            units.map((unit) => {
                if (!unitsByType[unit.unitType.type] &&
                    !unit.unitType.type.startsWith(UNIT_TYPE_ROYAL_COIN) &&
                    !unit.unitType.type.startsWith(UNIT_TYPE_DECOY_COIN)
                ) {
                    unitsByType[unit.unitType.type] = unit.unitType;
                }
            });

            return Object.values(unitsByType);
        },
        goToPage(page) {
            this.$store.dispatch('setRecentMatchesPage', page);
            this.getGames(page);
        },
        onClearFilters() {
            this.$store.dispatch('setRecentMatchesFilters', {
                base: false,
				champions: false,
				highSeas: false,
				mastery: false,
				nightfall: false,
				nobility: false,
				shockTactics: false,
				siege: false,
            });
            this.getGames(1);
        },
        onToggleBaseGameFilter(isChecked) {
            this.$store.dispatch('setRecentMatchesFilters', {
              	base: isChecked,
				champions: isChecked ? false : this.filters.champions,
				highSeas: isChecked ? false : this.filters.highSeas,
				mastery: isChecked ? false : this.filters.mastery,
				nightfall: isChecked ? false : this.filters.nightfall,
				nobility: isChecked ? false : this.filters.nobility,
				shockTactics: isChecked ? false : this.filters.shockTactics,
				siege: isChecked ? false : this.filters.siege,
            });
        },
        onToggleExpansionFilter(expansion, isChecked) {
            this.$store.dispatch('setRecentMatchesFilters', {
     			base: isChecked ? false : this.filters.base,
				champions:  expansion === 'champions' ? isChecked : this.filters.champions,
				highSeas: expansion === 'highSeas' ? isChecked : this.filters.highSeas,
				mastery: expansion === 'mastery' ? isChecked : this.filters.mastery,
				nightfall: expansion === 'nightfall' ? isChecked : this.filters.nightfall,
				nobility: expansion === 'nobility' ? isChecked : this.filters.nobility,
				shockTactics: expansion === 'shockTactics' ? isChecked : this.filters.shockTactics,
				siege: expansion === 'siege' ? isChecked : this.filters.siege,
            });
        },
        toggleExpansionIcon(expansion) {
            if (expansion === 'base') {
                this.onToggleBaseGameFilter(!this.filters.base);
            } else {
                this.onToggleExpansionFilter(expansion, !this.filters[expansion]);
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .matches {
        padding: 25px;

        .hide-on-mobile,
        .hide-on-medium  {
            display: none;
        }

        .loading-matches,
        .matches-placeholder {
            text-align: center;
            margin: 15px auto;
        }

        .filters-wrapper {
            display: flex;
            flex-direction: column;
            padding: 15px;
            margin: 15px auto;

            .expansion-filters {
                background: white;
                border: 1px solid $sage-brown;
                border-radius: 4px;
                box-shadow: 0 2px $sage-brown;
                color: $sage-brown;
                display: flex;
                padding: 15px;
                flex-direction: column;

                .pseudo-checkbox-wrapper {
                    cursor: pointer;
                    user-select: none;

                    &:not(:first-of-type) {
                        margin-top: 15px;
                    }
                }

                .filter-label {
                    margin-right: 5px;
                }

                > * {
                    align-self: center;
                }
            }

            .expansion-icons {
                display: flex;
                gap: 10px;
                justify-content: center;
                align-items: center;
                margin-bottom: 5px;
            }

            .expansion-filter-icon {
				width: 32px;
				height: 32px;
				min-height: 32px;
				min-width: 32px;
				border-radius: 50%;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				border: 1px solid $light-gray-alt;
				color: $sage-brown;
				cursor: pointer;
				transition: all .12s ease-in-out, transform .12s ease-in-out, box-shadow .12s ease-in-out;
				font-size: .75em;
				padding: 5px;
				box-sizing: border-box;
				box-shadow:
					0 2px 0 rgba(0, 0, 0, .12),
					0 3px 4px rgba(0, 0, 0, .15);

				&:active {
					box-shadow:
						0 0 0 rgba(0, 0, 0, .12),
						0 1px 2px rgba(0, 0, 0, .15);
				}

				&.text-label {
					font-size: .68rem;
				}
			}

			.expansion-filter-icon {

				.expansion-icon {
					max-height: 18px;
					max-width: 35px;
				}
			}

            .expansion-filter-icon.enabled {
				filter: none;
				opacity: 1;
				background: white;
				color: $green;
				fill: $green;
				border: 1px solid $green;
				box-shadow:
					0 2px 0 rgba(0, 100, 0, .18),
					0 3px 4px rgba(0, 0, 0, .15);
			}

            .expansion-filter-icon:not(.enabled) {
                opacity: .55;
				color: black;
            }

            .btn {
                font-size: .9em;
                margin-top: 15px;
            }
        }

        .stats-wrapper {
            text-align: center;
            margin-top: 15px;

            .stats {
                list-style-type: none;
                padding: 0;
                margin: 0;

                li {
                    display: inline-block;

                    &:not(:last-of-type) {
                        margin-right: 15px;
                    }
                }
            }
        }

        .disqualified-alert {
            color: $dark-brown;
            cursor: pointer;
            display: block;
            font-size: 1.2em;
            position: relative;
            text-align: center;
            margin: 0 auto;

            .disqualified-content {
                background: white;
                border: 2px solid $lancer;
                border-radius: 5px;
                display: inline-block;
                padding: 10px;
                position: relative;
                color: $lancer;

                > * {
                    display: inline-block;
                    vertical-align: middle;
                }

                .tooltip-icon {
                    margin-bottom: 1px;
                    vertical-align: middle;
                }
            }
        }

        .disqualified-tooltip {
            background: white;
            display: block;
            box-shadow: -1px 1px 2px 2px $light-sage-brown;
            font-size: .8rem;
            padding: 20px;
            position: absolute;
            left: 50%;
            text-align: left;
            top: 0;
            width: 250px;
            z-index: 5;
            transform: translateX(-50%);

            .tooltip-title {
                text-align: center;
            }

            .close-tooltip-btn {
                cursor: pointer;
                position: absolute;
                right: 15px;
                top: 15px;
            }
        }

        .overlay {
            background: transparent;
        }

        .matches-table {
            background: rgba(255, 255, 255, .85);
            border: 1px solid $light-gray;
            margin: 15px auto;
            width: 100%;

            th {
                color: $dark-brown;
                font-weight: bold;
            }

            td,
            th {
                padding: 10px 5px;
                vertical-align: middle;
                border-top: 1px solid $light-gray;
            }

            .replay-btn {
                display: none;
            }

            .replay-icon {
                background: $green;
                border-radius: 50%;
                color: white;
                cursor: pointer;
                font-size: .8em;
                margin: 0px 10px;
                padding: 10px;

                &.disabled {
                    background: $light-gray;
                    color: $gray;
                    cursor: not-allowed;
                }
            }

            .text-center {
                text-align: center;
            }

            .team-score-td {
                min-width: 100px;

                .team-score-wrapper {
					display: inline-flex;
					justify-content: center;
					align-items: center;
					gap: 5px;
                    margin-right: 10px;
                }
            }

            .royal-coin {
                height: 20px;
                vertical-align: middle;
                width: 20px;
            }

            .team-score {
                vertical-align: middle;
            }

            .match-date {
                min-width: 130px;
            }

            .match-player {
                text-align: center;

                .royal-coin {
                    margin-right: 7px;
                }

                .username {
                    display: flex;
                    justify-content: center;

                    .team-color {
                        vertical-align: middle;

                        .royal-coin {
                            vertical-align: baseline;
                        }
                    }
                }

                &:not(:last-of-type) {
                    margin-bottom: 7px;
                }

                .link {
                    color: $dark-blue;
                }
            }

            .match-result {

                &.win {
                    color: $archer;
                }

                &.loss {
                    color: $medium-dark-gray;
                }
            }

            .player-units {
                border-radius: 5px;
                line-height: 12px;
                margin-top: 5px;
                padding: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 4px;

                .unit-coin {
                    display: inline-block;
                    height: 25px;
                    width: 25px;
                }
            }

            .teams-wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;

                > * {
                    align-self: center;
                }

                .teams-separator {
                    padding: 15px 20px;
                }
            }

            .room-name-cell {
                padding: 15px 20px 15px 15px;
            }

            .ranked-cell {
                padding: 0 0 0 20px;
            }

            .btn {
                &.btn-3d {

                    &.disabled {
                        opacity: .6;
                        cursor: not-allowed;

                        &:hover {
                            top: 0;
                            box-shadow: 0 3px $medium-gray;
                        }
                    }
                }
            }

            .sr-change-cell {
                min-width: 40px;

                &.win {
                    color: $archer;

                    .sr-change-icon {
                    }
                }

                &.loss {
                    color: $medium-dark-gray;
                }

                .sr-change-icon {
                    line-height: 1em;
                    font-size: .8em;
                    vertical-align: middle;
                }

                .sr-change-value {
                    line-height: 1em;
                    vertical-align: middle;
                }
            }
        }

        .ranked-icon-wrapper {
            background: $light-gray-2;
            border: 1px solid $light-gray;
            display: inline-block;
            border-radius: 50%;
            height: 25px;
            width: 25px;
            position: relative;
            vertical-align: middle;
            color: $sage-brown;

            .ranked-icon {
                font-size: .9em;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);

                &.ranked {
                    color: $gold;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .matches {

            .filters-wrapper {
                flex-direction: row;
                justify-content: center;

                > * {
                    flex-grow: 1;
                }

                .opponent-search-bar {
                    margin-right: 7.5px;
                    width: calc(50% - 32px);
                }

                .unit-types-filter-wrapper {
                    margin-top: 0;
                    margin-left: 7.5px;
                    width: calc(50% - 32px);
                }

                .btn {
                    align-self: flex-start;
                    margin-left: 15px;
                    margin-top: 0;
                    max-width: 85px;
                }

                .btn-muted {
                    max-width: 85px;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-sm) {

        .matches {

            .title-wrapper {

                .title {
                    max-width: 600px;
                }
            }

            .matches-table {
                width: auto;

                .player-units {
                    margin-top: 10px;
                }

                .replay-btn {
                    display: inline-block;
                }

                .replay-icon {
                    display: none;
                }

                .teams-wrapper {
                    flex-direction: row;

                    .teams-separator {
                        padding: 0 20px;
                    }
                }
            }

            .filters-wrapper {
                max-width: 80%;

                .expansion-filters {
                    padding: 0 15px;
                    flex-direction: row;

                    .pseudo-checkbox-wrapper {

                        &:not(:first-of-type) {
                            margin-top: 0;
                            margin-left: 15px;
                        }
                    }
                }
            }
        }
    }

    @media only screen and (min-width: $screen-md) {

        .matches {

            .hide-on-mobile {
                display: table-cell;
            }

            .hide-on-medium {
                display: none;
            }

            .matches-table {

                td,
                th {
                    padding: 15px 20px;
                }
            }

            .matches-pagination {
                margin: 0 10%;
            }
        }
    }

    @media only screen and (min-width: $screen-lg) {

        .matches {

            .hide-on-medium {
                display: table-cell;
            }
        }
    }

</style>
